import { Content } from "./styled";
import error_icon from "../../../assets/icons/error.svg";

// variante "info": aviso amigavel (regra de negocio explicada), nao falha. Fica verde-claro,
// com role=status; a de erro continua vermelha com role=alert.
function Toast({error, variante = "erro"}){
  const info = variante === "info";
  return(
    <Content>
      <div className={`toast ${info ? 'info' : ''} ${error && 'active'}`} role={info ? 'status' : 'alert'} aria-live={info ? 'polite' : 'assertive'}>
        {info
          ? <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{ flex: "none", marginRight: 10 }}><circle cx="12" cy="12" r="11" fill="#17402A"/><rect x="11" y="10" width="2" height="7" rx="1" fill="#EAF4EC"/><circle cx="12" cy="7.2" r="1.3" fill="#EAF4EC"/></svg>
          : <img src={error_icon} alt=""/>} 
        <span>{error}</span>
      </div>
        
    </Content>
  );
}

export default Toast;
